import React, { useContext, useEffect, useState } from "react";
import "./AntiqueTheme.css";
import { Link } from "react-router-dom";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import Website from "../Common/websiteCards/Website";
// import QRModal from "../Common/QRModal";
import Downloads from "../Common/fileDownloadsCards/Downloads";
import Review from "../Common/reviewCards/Reviews";
import { IoLinkSharp } from "react-icons/io5";
import { MdReviews } from "react-icons/md";
import { FaExchangeAlt, FaFileDownload } from "react-icons/fa";
import ContactCard1 from "../Common/contactCards/ContactCard1";
import ListSocialMedia from "../Common/socialMedia/ListSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { UserOutlined } from '@ant-design/icons';
import { CardContext } from "../../store/CardContext";
import ListSocialMedias from "../Common/socialMedia/ListSocialMedias";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoCloseOutline, IoLink } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import WebsiteVex from "../Common/websiteCards/WebsiteVex";
import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import SlideSocialMediaStandard from "../Common/socialMedia/SlideSocialMediaStandard";
import SlideSocialMediaStd from "../Common/socialMedia/SlideSocialMediaStd";
import { TbArrowsExchange } from "react-icons/tb";
import ContactCardStd from "../Common/contactCards/ContactCardStd";
import { RiDirectionLine } from "react-icons/ri";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";
const defaultBackgroundImage = "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultBackground.jpg";
const defaultProfileImage = "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";

function AntiqueTheme({ card, preview, color }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleButtons = () => {
        setIsOpen(!isOpen);
    };
    const handleArrowClick = (e) => {
        e.stopPropagation();
    };

    const [cardData] = useContext(CardContext)
  

    
    const [contactExpand, setContactExpand] = useState(false);
   
    const [socialMediaExpand, setSocialMediaExpand] = useState(false);

    const [websiteExpand, setWebsiteExpand] = useState(false);
    const [reviewExpand, setReviewExpand] = useState(false);
    const [downloadsExpand, setDownloadsExpand] = useState(false);
    const [galleryExpand, setGalleryExpand] = useState(false);
    const [videoExpand, setVideoExpand] = useState(false);

const toggleSection = (section) => {
    switch (section) {
      case 'contact':
        setContactExpand(!contactExpand);
        break;
      case 'socialMedia':
        setSocialMediaExpand(!socialMediaExpand);
        break;
      case 'website':
        setWebsiteExpand(!websiteExpand);
        break;
      case 'review':
        setReviewExpand(!reviewExpand);
        break;
      case 'downloads':
        setDownloadsExpand(!downloadsExpand);
        break;
      case 'gallery':
        setGalleryExpand(!galleryExpand);
        break;
      case 'video':
        setVideoExpand(!videoExpand);
        break;
      default:
        break;
    }
  };

    const {
        backgroundImage,
        profileImage,
        personalDetails,
        website,
        review,
        contactDetails,
        fileName,
        files,
        vCard,
        checkProfile,
        checkPfCard,
        footerText
    } = cardData

    // const Highlightcolor = card?.colorCode ? card?.colorCode : "";
    const Textcolor = card?.textColor ? card?.textColor : "#000000";;
    const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#FFFFFF";
    // const BgColor = card?.bgColor ? card?.bgColor : "";
    const BtIColor = card?.btIconColor ? card?.btIconColor : "#888888";

    const iconColor = color ? color : '#FFFFFF'

    const BgColor = card?.bgColor ? card?.bgColor : "#FFFFFF";
    const Highlightcolor = card?.colorCode ? card?.colorCode : "#2D2D2D";


   


  




    const [qrModal, setQrModal] = useState(false);
    const SocialMediaImageCheck = SocialMediaValid();
    const HighlightImageCheck = HighlightImageValid();




    const handleClose = (e) => {
        setQrModal(false);
    };




    const rightArrow = (
        <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.36146 6.76349C8.55674 6.95883 8.66644 7.22373 8.66644 7.49994C8.66644 7.77616 8.55674 8.04106 8.36146 8.2364L2.46875 14.1291C2.37266 14.2286 2.25772 14.308 2.13063 14.3626C2.00354 14.4171 1.86686 14.4459 1.72854 14.4471C1.59023 14.4483 1.45307 14.4219 1.32505 14.3696C1.19703 14.3172 1.08073 14.2398 0.982923 14.142C0.885118 14.0442 0.807771 13.9279 0.755395 13.7999C0.703019 13.6719 0.676663 13.5347 0.677865 13.3964C0.679067 13.2581 0.707803 13.1214 0.762396 12.9943C0.816988 12.8672 0.896344 12.7523 0.995834 12.6562L6.15208 7.49994L0.995834 2.34369C0.806086 2.14723 0.701092 1.88411 0.703465 1.61098C0.705839 1.33786 0.81539 1.0766 1.00852 0.883466C1.20166 0.690333 1.46292 0.580782 1.73604 0.578409C2.00916 0.576035 2.27229 0.681029 2.46875 0.870777L8.36146 6.76349Z"
                fill={BtIColor || "#888888"}
            />
        </svg>
    );

    const downArrow = (
        <svg
            width="15"
            height="18"
            viewBox="0 0 15 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23645 8.36143C8.04111 8.55671 7.77621 8.66641 7.49999 8.66641C7.22378 8.66641 6.95888 8.55671 6.76354 8.36143L0.870828 2.46872C0.771337 2.37263 0.69198 2.25769 0.637387 2.1306C0.582795 2.00351 0.55406 1.86682 0.552858 1.72851C0.551657 1.5902 0.578012 1.45304 0.630388 1.32502C0.682764 1.197 0.760112 1.0807 0.857917 0.982892C0.955722 0.885087 1.07202 0.80774 1.20004 0.755364C1.32806 0.702988 1.46523 0.676632 1.60354 0.677834C1.74185 0.679036 1.87854 0.707772 2.00562 0.762365C2.13271 0.816957 2.24765 0.896313 2.34374 0.995803L7.49999 6.15205L12.6562 0.995804C12.8527 0.806056 13.1158 0.701062 13.389 0.703435C13.6621 0.705808 13.9233 0.815359 14.1165 1.00849C14.3096 1.20163 14.4192 1.46289 14.4215 1.73601C14.4239 2.00913 14.3189 2.27226 14.1292 2.46872L8.23645 8.36143Z"
                fill={BtIColor || "#888888"}
            />
        </svg>
    );

    const handleShare = () => {
        if (navigator.share) {
            navigator
                .share({
                    text: "Please check it out.",
                    url: window.location.href,
                    title: "ZEEQR",
                })
                .then(() => console.log("Successful share"))
                .catch((error) => console.log("Error sharing", error));
        }
    };


    function isDarkColor(color) {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness < 128;
    }
    const exchangeButton = (
        <button
            className="flex justify-center items-center text-[12px] p-2 gap-3 h-[45px] rounded-[6px] w-full"
            style={{
                border: `2px solid ${Highlightcolor || "black"}`,
                color: Highlightcolor || "black",
            }}
        >
            <TbArrowsExchange className="w-4 h-4" />
            Exchange Contacts
        </button>
    )

    const directionButton = (
        <button
            // onClick={onClick}
            className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
            style={{
                backgroundColor: Highlightcolor || "black",
                color: isDarkColor(Highlightcolor) ? "white" : "black",
            }}
        >
            <RiDirectionLine
                className="mr-2"
                size={18}
                
            />
            <span className="font-medium text-[12px]" >
                Directions
            </span>
        </button>
    )


    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button) => {
        // console.log("iiii");

        updateTapCount(queryClient, button);
    };
    const imageStyle = {
        backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
        backgroundPosition: "center 10px",
        backgroundImage: `url(${card?.bgImg})`,
        backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",
    
      };
      const colorStyle = {
        backgroundSize: "100%",
        backgroundPosition: "center ",
        backgroundColor: BgColor,
      };
      const defaultStyle = {
        backgroundSize: "100%",
        backgroundPosition: "center ",
        backgroundImage: 'white'
      };
    return (
        <div className="previewWrapantique" >
            <div className="relative">
                <div className="bannerImageantique relative">
                    {backgroundImage ? (
                        <img
                            src={backgroundImage}
                            alt=""
                        />
                    ) : (
                        <img src={defaultBackgroundImage} alt="" />
                    )}
                      <div className="absolute inset-0  opacity-50" style={{ background: Highlightcolor}}></div>
                </div>
                {checkPfCard ? (

<div className="flex items-center m-auto justify-center ">
                        
<div className="absolute top-4  ">

                            {card?.companyLogo && card?.checkLogo && (
                                <div
                                    className=" h-10 flex items-center justify-center "

                                >
                                    <img
                                        src={card?.companyLogo}
                                        alt="Company Logo"
                                        className="object-contain w-full h-full"
                                    />
                                </div>
                            )}

                     

                            {checkProfile ? (
                                <div className=" border mt-2 border-2 border-none  rounded-[50%]">
                                    {profileImage ? (
                                        <img
                                            src={profileImage}
                                            alt=""
                                            className="w-[130px] h-[130px] border border-2 border-none   rounded-[50%]"
                                        />
                                    ) : (
                                        <img src={defaultProfileImage} alt="" className="w-[130px] h-[130px] border border-2 border-none   rounded-[50%]" />
                                    )}
                                </div>
                            ) : (
                                ""
                            )}

                       
<p
        className="text-center tracking-normal mt-2 m-0 text-[24px] font-bold"
        style={{ color: isDarkColor(Highlightcolor) ? "white" : "black" }}
    >
        {personalDetails?.name ? personalDetails.name : ""}
    </p>
    <p
        className="text-[12px] font-normal mt-2 text-center"
        style={{ color: isDarkColor(Highlightcolor) ? "white" : "black" }}
    >
        {personalDetails?.companyDesignation
            ? personalDetails.companyDesignation
            : ""}
    </p>

                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>

            <div className="absolute top-[280px] w-full"   style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}>

                <div className="">
                    <svg
                        width="100%"
                        height="115"
                        viewBox="0 0 393 115"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_193_93)">
                            <path
                                d="M178.5 76.0017C31 72.7247 94 -1.99827 -108 23.0017L-58.5 668.001H394L594 246C594 209 554.5 31.5013 353.5 0.500583C287.5 -9.67875 227 77.0792 178.5 76.0017Z"
                                fill="#A5A5A5"
                            />
                            <path
                                d="M172 67.5002C107.5 90.0002 91.5 4.00016 0 57.5002V665.5H403V32.5001C396.833 36.6668 372.3 42.5001 323.5 32.5001C262.5 20.0001 236.5 45.0002 172 67.5002Z"
                                fill="#D9D9D9"
                            />
                            <path
                                d="M241.594 62.7784C180.857 75.2726 116.391 14.3006 -20 62.7784V669H427V62.7784C421.672 51.2836 404.091 26.9947 376.386 21.7971C341.756 15.3001 302.33 50.2841 241.594 62.7784Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_193_93">
                                <rect width="393" height="115" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div className="flex justify-center gap-4  w-full mb-5 mt-5">
                    <Link
                        onClick={() => handleTap('saveContact')}
                        to={`${preview ? vCard : ""}`}
                        // target={`${preview ? "_blank" : ""}`}
                        className="blk-btn w-1/2"
                    >
                        <button
                            className="flex justify-center items-center p-2 text-[12px] gap-2 h-[45px] rounded-[6px] w-full"
                            style={{
                                background: Highlightcolor || "black",
                                color: isDarkColor(Highlightcolor) ? "white" : "black",
                            }}
                        >
                          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 8C9.29493 8 10.75 6.54493 10.75 4.75C10.75 2.95507 9.29493 1.5 7.5 1.5C5.70507 1.5 4.25 2.95507 4.25 4.75C4.25 6.54493 5.70507 8 7.5 8Z"        stroke={isDarkColor(Highlightcolor) ? "white" : "black"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.68 14.5C13.2602 13.1908 12.4355 12.0488 11.3248 11.2386C10.2141 10.4284 8.8748 9.99182 7.5 9.99182C6.1252 9.99182 4.78591 10.4284 3.67522 11.2386C2.56453 12.0488 1.73982 13.1908 1.32 14.5H13.68Z" stroke={isDarkColor(Highlightcolor) ? "white" : "black"}  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            <span
                                className="text-[12px]"
                                style={{
                                    color: isDarkColor(Highlightcolor) ? "white" : "black",
                                }}
                            >
                                Add to contacts
                            </span>
                        </button>
                    </Link>
                    {card?.exchangeContact?.show ?
                        <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                        : ""
                    }

                </div>
                <div>
                    <div
                        className="w-full items-center h-full  p-[8px] flex items-center rounded-[12px] justify-between"
                        style={{
                            borderColor: Highlightcolor || "transparent",
                            borderWidth: Highlightcolor ? '1px' : '0',
                        }}
                    >

                        <div className="w-full">
                            <details>
                                <summary
                                    className="flex pr-4 items-center justify-between cursor-pointer"
                                    onClick={() => toggleSection('contact')}
                                >
                                    <div className="py-2 flex p-2 gap-3 items-center ">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.95385 25C4.37757 22.9133 5.50966 21.0373 7.15831 19.6898C8.80695 18.3422 10.8707 17.6061 13 17.6061C15.1293 17.6061 17.1931 18.3422 18.8417 19.6898C20.4904 21.0373 21.6225 22.9133 22.0462 25M17.6154 10.2308C17.6154 12.7798 15.549 14.8462 13 14.8462C10.451 14.8462 8.38463 12.7798 8.38463 10.2308C8.38463 7.68176 10.451 5.61538 13 5.61538C15.549 5.61538 17.6154 7.68176 17.6154 10.2308ZM2.84616 1H23.1539C24.1735 1 25.0001 1.82655 25.0001 2.84615V23.1538C25.0001 24.1734 24.1735 25 23.1539 25H2.84616C1.82655 25 1 24.1734 1 23.1538V2.84615C1 1.82655 1.82655 1 2.84616 1Z" stroke={BtIColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <p
                                            className="w-[240px] m-0"
                                            style={{
                                                color: `${Textcolor}`,
                                            }}
                                        >
                                            Contact Information
                                        </p>
                                    </div>
                                    <div>
                                        {contactExpand ? downArrow : rightArrow}
                                    </div>
                                </summary>

                               
                                    <ContactCardStd preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} customButton={directionButton} />

                                
                            </details>
                        </div>
                    </div>
                </div>

                {/* --------------------------------- social ---------------------------------  */}
                {SocialMediaImageCheck || (card?.socialMedias && card?.socialMedias.length !== 0) ? (
    <div className="mt-5">
     <div
                        className="w-full items-center h-full  p-[8px] flex items-center rounded-[12px] justify-between"
                        style={{
                            borderColor: Highlightcolor || "transparent",
                            borderWidth: Highlightcolor ? '1px' : '0',
                        }}
                    >
            <details className=" items-center w-full justify-between text-black">
                <summary className="flex pr-4 items-center justify-between"     onClick={() => toggleSection('socialMedia')}>
                    <div className="flex py-2 gap-3 p-2 items-center">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.51498 21.4855C2.83665 19.8073 1.69368 17.6691 1.23061 15.3412C0.767545 13.0134 1.00519 10.6005 1.91348 8.40773C2.82177 6.21495 4.35992 4.34077 6.33341 3.0222C8.30689 1.70363 10.6271 0.999898 13.0005 1M21.4861 4.51446C23.1644 6.19269 24.3074 8.33094 24.7704 10.6588C25.2335 12.9866 24.9959 15.3995 24.0876 17.5923C23.1793 19.785 21.6411 21.6592 19.6676 22.9778C17.6941 24.2964 15.374 25.0001 13.0005 25M10.4602 10.7225L12.4067 14.6148M10.4602 10.7225L15.0011 6.18154L18.8928 13.9662L12.4067 14.6148M10.4602 10.7225L7.86575 12.0197C7.08606 12.4092 7.1519 13.8351 7.54144 14.6148C7.93098 15.3945 9.03252 16.3015 9.81221 15.912L12.4067 14.6148M11.8331 14.9458L13.4547 18.1889L12.1574 18.8375L10.5359 15.5945M21.595 3.75692C21.595 4.83158 20.7238 5.70277 19.6491 5.70277C18.5745 5.70277 17.7033 4.83158 17.7033 3.75692C17.7033 2.68226 18.5745 1.81108 19.6491 1.81108C20.7238 1.81108 21.595 2.68226 21.595 3.75692ZM8.29775 22.2431C8.29775 23.3177 7.42657 24.1889 6.3519 24.1889C5.27724 24.1889 4.40606 23.3177 4.40606 22.2431C4.40606 21.1684 5.27724 20.2972 6.3519 20.2972C7.42657 20.2972 8.29775 21.1684 8.29775 22.2431Z"
                                stroke={BtIColor}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <p className="w-[240px] m-0" style={{ color: Textcolor }}>
                            Social Media
                        </p>
                    </div>
                    <div>
                        {socialMediaExpand ? downArrow : rightArrow}
                    </div>
                </summary>
                {card?.socialMedias && card?.socialMedias.length !== 0 ? (
                    <ListSocialMedias 
                        preview={preview} 
                        Textcolor={Textcolor} 
                        Highlightcolor={Highlightcolor} 
                        Iconcolor={Iconcolor} 
                        BtIColor={BtIColor} 
                    />
                ) : (
                    <ListSocialMedia 
                        preview={preview} 
                        Textcolor={Textcolor} 
                        Highlightcolor={Highlightcolor} 
                        Iconcolor={Iconcolor} 
                        BtIColor={BtIColor} 
                    />
                )}
            </details>
        </div>
    </div>
) : (
    ""
)}

                {/* ------------------Webiste_Area--------------------------------------------------------- */}
                {website[0]?.websiteName ? (
                    <div className="mt-5">
                        <div
                            className="  w-full   h-full text-white   p-[8px] flex rounded-[12px] justify-between"
                            style={{
                                borderColor: Highlightcolor || "transparent", // Default to 'transparent' if no color
                                borderWidth: Highlightcolor ? '1px' : '0',    // Add border width when Highlightcolor exists
                            }}
                           
                        >
                            <details className="justify-between w-full items-center">
                                <summary className="flex pr-4  items-center justify-between" onClick={() => toggleSection('website')}>
                                    <div className="py-2 p-2 gap-3 flex items-center">
                                        <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.28 6C2.28 3.948 3.948 2.28 6 2.28H10.8V0H6C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12H10.8V9.72H6C3.948 9.72 2.28 8.052 2.28 6ZM7.2 7.2H16.8V4.8H7.2V7.2ZM18 0H13.2V2.28H18C20.052 2.28 21.72 3.948 21.72 6C21.72 8.052 20.052 9.72 18 9.72H13.2V12H18C21.312 12 24 9.312 24 6C24 2.688 21.312 0 18 0Z" fill={BtIColor || "#888888"} />
                                        </svg>

                                        {/* <IoLinkSharp color={Textcolor} size={20} className="w-[40px]" /> */}
                                        <p
                                            className="w-[240px] m-0"
                                            style={{
                                                color: `${Textcolor}`,
                                            }}

                                        >
                                            Website Links
                                        </p>
                                    </div>
                                    <div>
                                        {websiteExpand ? downArrow : rightArrow}
                                    </div>
                                </summary>

                           
                                    <Website website={website} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />

                                
                            </details>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* ------------------Webiste_Area Ends--------------------------------------------------------- */}

                {/* ------------------Review_Area--------------------------------------------------------- */}
                {review[0]?.reviewName ? (
                    <div className="mt-5">
                        <div
                            className="  w-full   h-full text-white   p-[8px] flex rounded-[12px] justify-between"
                            style={{
                                borderColor: Highlightcolor || "transparent", // Default to 'transparent' if no color
                                borderWidth: Highlightcolor ? '1px' : '0',    // Add border width when Highlightcolor exists
                            }}
                        >
                            <details className="justify-between w-full items-center">
                                <summary className="flex pr-4  items-center justify-between" onClick={() => toggleSection('review')}>
                                    <div className="py-2 flex p-2 gap-3 items-center">
                                        {/* <MdReviews color={Textcolor} size={20} className="w-[40px]" /> */}
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.99914 20.4951L12.0008 17.3209L17.0024 20.5368L15.6925 14.5226L20.0987 10.5132L14.3031 9.97021L12.0008 4.29013L9.69845 9.92844L3.90288 10.4714L8.3091 14.5226L6.99914 20.4951ZM4.5777 24L6.54661 15.124L0 9.15662L8.62349 8.37143L12.0008 0L15.3781 8.36976L24 9.15495L17.4534 15.1224L19.4239 23.9983L12.0008 19.2872L4.5777 24Z" fill={BtIColor || "#888888"} />
                                        </svg>

                                        <p
                                            className="w-[240px] m-0 "
                                            style={{
                                                color: `${Textcolor}`,
                                            }}
                                            
                                        >
                                            Review
                                        </p>
                                    </div>
                                    <div
                                        onClick={() => {
                                            setReviewExpand(!reviewExpand);
                                        }}
                                    >
                                        {reviewExpand ? downArrow : rightArrow}
                                    </div>
                                </summary>

                                {/* <ReviewSection review={review} /> */}
                                <Review review={review} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />


                            </details>
                        </div>
                    </div>
                ) : (
                    ""
                )}






                {/* ------------------Downloads_Area--------------------------------------------------------- */}

                {fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ? (
                    <div className="mt-5">
                        <div
                            className="  w-full   h-full text-white   p-[8px] flex rounded-[12px] justify-between"
                            style={{
                                borderColor: Highlightcolor || "transparent", // Default to 'transparent' if no color
                                borderWidth: Highlightcolor ? '1px' : '0',    // Add border width when Highlightcolor exists
                            }}
                          
                        >
                            <details className=" justify-between w-full items-center">
                                <summary className="flex pr-4   items-center justify-between"   onClick={() => toggleSection('downloads')}>
                                    <div className="p-2 gap-3  flex items-center">
                                        <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6667 1V9H19.6667M3.66667 25C2.95942 25 2.28115 24.719 1.78105 24.219C1.28095 23.7189 1 23.0406 1 22.3333V1H13L19.6667 7.66667V22.3333C19.6667 23.0406 19.3857 23.7189 18.8856 24.219C18.3855 24.719 17.7072 25 17 25H3.66667Z" fill={BtIColor || "#888888"} stroke-width="2" stroke-linejoin="round" />
                                        </svg>

                                        {/* <FaFileDownload color={Textcolor} size={20} className="w-[40px]" /> */}
                                        <p
                                            className="w-[240px] m-0 "
                                            style={{
                                                color: `${Textcolor}`,
                                            }}

                                        >
                                            Attachments
                                        </p>
                                    </div>
                                    <div>
                                        {downloadsExpand ? downArrow :rightArrow }
                                    </div>
                                </summary>
                                {/* <DownloadsSection files={files} fileName={fileName} /> */}
                                <DownloadBasic files={files} fileName={fileName} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />


                            </details>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* ------------------Files_Area Ends--------------------------------------------------------- */}


                {HighlightImageCheck ?
                    <div className="mt-5">
                        <div
                            className="  w-full  h-full text-white p-[8px]   flex rounded-[12px] justify-between"
                            style={{
                                borderColor: Highlightcolor || "transparent", // Default to 'transparent' if no color
                                borderWidth: Highlightcolor ? '1px' : '0',    // Add border width when Highlightcolor exists
                            }}
                    
                        >
                            <details className="justify-between w-full items-center">
                                <summary className="flex pr-4  items-center justify-between"         onClick={() => toggleSection('gallery')}>
                                    <div className="py-2 p-2 gap-3 items-center flex ">
                                        <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 17.538V3.69185C1 3.20222 1.1945 2.73265 1.54073 2.38643C1.88695 2.04021 2.35652 1.8457 2.84615 1.8457H19.4615M6.72308 22.0057L13.9785 14.3441C14.1501 14.1556 14.3589 14.0046 14.5917 13.9007C14.8245 13.7968 15.0764 13.7423 15.3313 13.7405C15.5863 13.7388 15.8389 13.7899 16.0731 13.8906C16.3073 13.9913 16.5182 14.1395 16.6923 14.3257L23.9846 21.9687M23.1538 22.1533H7.46154C6.44194 22.1533 5.61539 21.3268 5.61539 20.3072V8.30723C5.61539 7.28763 6.44194 6.46108 7.46154 6.46108H23.1538C24.1734 6.46108 25 7.28763 25 8.30723V20.3072C25 21.3268 24.1734 22.1533 23.1538 22.1533Z" stroke={BtIColor || "#888888"} stroke-width="1.84615" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        {/* <GrGallery color={Textcolor} size={20} className="w-[40px]" /> */}

                                        <p
                                            className="w-[240px]  m-0 "
                                            style={{
                                                color: `${Textcolor}`,
                                            }}

                                        >
                                            {" "}
                                            Gallery{" "}
                                        </p>
                                    </div>

                                    <div>
                                        {galleryExpand ? downArrow : rightArrow}
                                    </div>
                                </summary>
                           
                                    <div>
                                        <HighlightImage />
                                    </div>
                            
                            </details>
                        </div>
                    </div>
                    : ""

                }

                {/*  --------------------------------- footer ---------------------------------  */}
                {footerText &&
                    <div className="mt-10">

                        <Footer color={Textcolor} />
                    </div>
                }

                {/* {preview ? (
                            <div className="flex justify-center gap-[20px] fixed top-[90%] items-center left-[26%] lg:left-[45%]   ">
                                {card?.exchangeContact?.show ?
                                    <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                                    : ""
                                }
                                <button
                                    onClick={handleShare}
                                    className="w-[50px] h-[50px] p-[10px] rounded-[12px]   "
                                    style={{
                                        backgroundColor: `${Iconcolor}`,
                                    }}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22Z"
                                            fill={BtIColor}
                                        />
                                    </svg>
                                </button>
                                <button
                                    onClick={() => setQrModal(true)}
                                    className="w-[50px] h-[50px] p-[10px] rounded-[12px] bg-white "
                                    style={{
                                        backgroundColor: `${Iconcolor}`,
                                    }}
                                >
                                    <svg
                                        width="34"
                                        height="34"
                                        viewBox="0 0 34 34"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
                                            fill={BtIColor}
                                        />
                                    </svg>
                                </button>
                            </div>
                        ) : (
                            ""
                        )} */}
                {preview ? (
                    <div className="fixed bottom-0 right-7 z-10 space-y-4">
                        {!isOpen && (
                            <div className="relative group">
                                <div className="flex items-center space-x-2">
                                    <span
                                        className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                                        style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                                    >
                                        Share
                                    </span>
                                    <button
                                        onClick={toggleButtons}
                                        className="border rounded-full p-2 bg-blue-500 hover:bg-blue-600 transition-transform duration-[1s] ease-in-out"
                                        style={{
                                            backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                                            borderColor: `${Highlightcolor ? Highlightcolor : ""}`
                                        }}
                                    >
                                        <IoShareSocialOutline size={23} color={iconColor} />
                                    </button>
                                </div>
                            </div>
                        )}

                        {isOpen && (
                            <>
                                {/* Profile Link Button */}
                                <div
                                    className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                                        }`}
                                    style={{ transitionDelay: '0.1s' }}
                                >
                                    <div className="flex items-center space-x-2">
                                        <span
                                            className="absolute -left-24 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                                            style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                                        >
                                            Profile Link
                                        </span>
                                        <button
                                            onClick={handleShare}
                                            className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                                            style={{ color: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}

                                        >
                                            <IoLink size={23} />
                                        </button>
                                    </div>
                                </div>

                                {/* QR Code Button */}
                                <div
                                    className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                                        }`}
                                    style={{ transitionDelay: '0.2s' }}
                                >
                                    <div className="flex items-center space-x-2">
                                        <span
                                            className="absolute -left-16 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                                            style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                                        >
                                            QR Code
                                        </span>
                                        <button
                                            onClick={() => setQrModal(true)}
                                            className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out" style={{ borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                                        >
                                            <BsQrCodeScan size={23} style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }} />
                                        </button>
                                    </div>
                                </div>

                                {/* Close Button */}
                                <div
                                    className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                                        }`}
                                    style={{ transitionDelay: '0.3s' }}
                                >
                                    <div className="flex items-center space-x-2">
                                        <span
                                            className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                                            style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                                        >
                                            Close
                                        </span>
                                        <button
                                            onClick={toggleButtons}
                                            className="border rounded-full p-2 text-white cursor-pointer transition-transform duration-[1s] ease-in-out"
                                            style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                                        >
                                            <IoCloseOutline size={23} color={iconColor} />
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    // <div className="flex justify-center gap-[20px] fixed top-[90%] lg:left-[45%] left-[35%]   ">
                    //   <button
                    //     className="w-[50px] h-[50px] flex justify-center p-[15px] rounded-[12px] shadow bg-white"
                    //     onClick={handleShare}
                    //   >
                    //     <svg
                    //       width="24"
                    //       height="24"
                    //       viewBox="0 0 24 24"
                    //       fill="none"
                    //       xmlns="http://www.w3.org/2000/svg"
                    //     >
                    //       <path
                    //         d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22Z"
                    //         fill="black"
                    //       />
                    //     </svg>
                    //   </button>
                    //   <button
                    //     className="w-[50px] h-[50px] flex justify-center shadow p-[10px] rounded-[12px] bg-white"
                    //     onClick={() => setQrModal(true)}
                    //   >
                    //     <svg
                    //       width="34"
                    //       height="34"
                    //       viewBox="0 0 34 34"
                    //       fill="none"
                    //       xmlns="http://www.w3.org/2000/svg"
                    //     >
                    //       <path
                    //         d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
                    //         fill={Highlightcolor ? Highlightcolor : "black"}
                    //       />
                    //     </svg>
                    //   </button>

                    //   {card?.exchangeContact?.show ?
                    //     <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                    //     : ""
                    //   }

                    // </div>
                ) : (
                    ""
                )}
            </div>
            {qrModal ? <QRModal handleClose={handleClose} /> : null}

        </div >
    );
}

export default AntiqueTheme;